import axios from "../../utils/axios";

export type TabDetailsStateResponse = {
    isReadonly: boolean;
    readonlyReason: string;
}

export const getTabDetailsState = (rfpId: string) => axios
    .get(`/api/v1/frontend/tenders/facility-manager/${ rfpId }/tab-details-state`)
    .then((response: { data: { data: TabDetailsStateResponse } }) => response.data.data)
